"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.severities = void 0;
var react_1 = __importDefault(require("react"));
var colors_1 = require("../util/colors");
var spacing_1 = require("./spacing");
exports.severities = {
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};
var severityColors = {
    info: colors_1.colors.gray50,
    warn: colors_1.colors.orange50,
    error: colors_1.colors.red50,
};
var Notice = function (_a) {
    var color = _a.color, severity = _a.severity, children = _a.children, _b = _a.noticeProps, noticeProps = _b === void 0 ? {} : _b, rest = __rest(_a, ["color", "severity", "children", "noticeProps"]);
    return (react_1.default.createElement(spacing_1.Div, __assign({}, rest),
        react_1.default.createElement(spacing_1.Div, __assign({ p: 2 }, noticeProps, { style: __assign({ borderRadius: '8px', backgroundColor: color || severityColors[severity || 'info'] }, noticeProps.style) }), children)));
};
exports.default = Notice;
//# sourceMappingURL=Notice.js.map